import growthAcquisitionExperiments from 'bundles/epic/clients/GrowthAcquisition';

export const isArkoseBotManagerForSignupEnabled = () =>
  growthAcquisitionExperiments.preview('enableArkoseBotManagerForSignup');

export const isArkoseVanillaImplementationEnabled = () =>
  growthAcquisitionExperiments.preview('enableArkoseVanillaImplementation');

export const isInPasswordlessSignupVariant = () => growthAcquisitionExperiments.preview('passwordlessSignup');

export const generateImpressionForPasswordlessSignup = () => growthAcquisitionExperiments.get('passwordlessSignup');

export const generateImpressionForVisualChangesToAuthModal = () =>
  growthAcquisitionExperiments.get('visualChangesToAuthModal');

export const getVisualChangesToAuthModalVariant = () =>
  growthAcquisitionExperiments.preview('visualChangesToAuthModal');

export const shouldFlattenSocialSSOButtons = () =>
  getVisualChangesToAuthModalVariant() === 'A' || getVisualChangesToAuthModalVariant() === 'B';

export const shouldShowSocialSSOButtonsAboveEmailSignup = () => getVisualChangesToAuthModalVariant() === 'B';

export const shouldShowSocialSSOButtonsBelowEmailSignup = () =>
  getVisualChangesToAuthModalVariant() !== 'C' && !shouldShowSocialSSOButtonsAboveEmailSignup();
